import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { NgForm } from "@angular/forms";

import { Loan } from "../shared/loan";
import { LoanService } from "../shared/loan.service";

@Component({
  selector: 'app-branchapproval',
  templateUrl: './branchapproval.component.html',
  styleUrls: ['./branchapproval.component.css']
})
export class BranchapprovalComponent implements OnInit {

  displayedColumns: string[] = ['Application No', 'Application Date', 'Customer', 'Scheme', 'Amount', 'Approved As', 'Branch', 'Mobile', 'New'];

  LoanList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selected = new FormControl(0);
  LoanApprovedStatus: number = 0;  // because we need pending list for pending status
  public selectedLoan: Loan;
  //   -- 0 for pending status
  //   -- 1 for branch Approved Status
  //   -- 2 for loan Approved Status
  //   -- 3 for branch reject status
  //   -- 4 for loan reject status   
  //   -- 5 for branch revert status  // using for any document clearance.
  //   -- 6 for loan revert status    // using for any document clearance.

  constructor(private router: Router, 
    public loanService: LoanService) { }

  ngOnInit() {
    this.getLoanList();
    this.dataSource.paginator = this.paginator;
  }

  getLoanList() {    
    this.selectedLoan = new Loan();
    this.selectedLoan.SearchByApprovedStatus  = 0;  // pending case.
    this.selectedLoan.LoanApprovedStatusId = this.LoanApprovedStatus;

    this.loanService.FetchLoanList(this.selectedLoan)
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
        console.log(data);
      })
      .catch(err => { console.log(err) });
  }

  public ApprovalTabIndex = 0;

  public ApprovalAction(loan: any) {
    const tabCount = 2;
    this.ApprovalTabIndex = (this.ApprovalTabIndex + 1) % tabCount;

    this.loanService.selectedLoan.Id =  loan.Id;
    this.loanService.selectedLoan.IsCustomerSearch =  true;
    this.loanService.selectedLoan.LoanApprovedStatusId = this.LoanApprovedStatus;

    this.loanService.LoanApprovalByLoanNo(this.loanService.selectedLoan).toPromise().then(data => {

      this.loanService.selectedLoan.Id = data.Id;
      this.loanService.selectedLoan.CustomerId = data.CustomerId;
      this.loanService.selectedLoan.ApplicationNo = data.ApplicationNo;
      this.loanService.selectedLoan.ApplicationDate = data.ApplicationDate;
      this.loanService.selectedLoan.Recommendation = data.Recommendation;
      this.loanService.selectedLoan.ApprovedRemarks = data.ApprovedRemarks;
      this.loanService.selectedLoan.LoanTypeId = data.LoanTypeId;
      this.loanService.selectedLoan.LoanAmount = data.LoanAmount;
      this.loanService.selectedLoan.Schemename = data.SchemeName;
      this.loanService.selectedLoan.InterestType = data.InterestType;
      this.loanService.selectedLoan.CustomerName = data.CustomerName;
      this.loanService.selectedLoan.CustomerAddress = data.CustomerAddress;
    })
      .catch(err => { console.log(err) });
  }

  ViewLoan(loan: any) {
    this.router.navigate(['/loan', loan.Id]);
  }

  ClickApprove(event) {
    this.loanService.selectedLoan.LoanApprovedStatusId = 1;  // 1 for branch manager approval 
    this.loanService.selectedLoan.IsApprovalClick = true;    // for selecting SP only
    this.IUDRevert_Reject_Approve();
  }

  ClickReject(event) {
    this.loanService.selectedLoan.LoanApprovedStatusId = 3;  // 3 for branch reject status
    this.loanService.selectedLoan.IsApprovalClick = true;    // for selecting SP only
    this.IUDRevert_Reject_Approve();
  }

  ClickRevert(event) {
    this.loanService.selectedLoan.LoanApprovedStatusId = 5;  // 5 for branch revert status 
    this.loanService.selectedLoan.IsApprovalClick = true;    // for selecting SP only
    this.IUDRevert_Reject_Approve();
  }

  IUDRevert_Reject_Approve() {
    this.loanService.selectedLoan.LoanApprovedBy = JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.loanService.selectedLoan.LoanApprovedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    
    if (this.loanService.selectedLoan.CustomerName != null) {
      this.loanService.IUDLoan(this.loanService.selectedLoan)
        .toPromise()
        .then(data => {
          this.getLoanList();
        })
    }
    this.ApprovalTabIndex = 0;
  }
}
